<template></template>
<script>
export default {
  created() {
    // console.log(this.$route.query);
    window.location.replace(
      '/mine/?source=notion_sync&code=' + this.$route.query.code + '&state=' + this.$route.query.state,
    )
  },
}
</script>
